import { render, staticRenderFns } from "./InformationTableImage.vue?vue&type=template&id=368b9d21&scoped=true&"
import script from "./InformationTableImage.vue?vue&type=script&lang=js&"
export * from "./InformationTableImage.vue?vue&type=script&lang=js&"
import style0 from "./InformationTableImage.vue?vue&type=style&index=0&id=368b9d21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b9d21",
  null
  
)

export default component.exports